var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.300049 11.2V14.5C0.300049 16.3226 3.74745 17.8 8.00005 17.8C12.2526 17.8 15.7 16.3226 15.7 14.5V11.2C15.7 13.0226 12.2526 14.5 8.00005 14.5C3.74745 14.5 0.300049 13.0226 0.300049 11.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.300049 5.70001V9.00001C0.300049 10.8226 3.74745 12.3 8.00005 12.3C12.2526 12.3 15.7 10.8226 15.7 9.00001V5.70001C15.7 7.52255 12.2526 9.00001 8.00005 9.00001C3.74745 9.00001 0.300049 7.52255 0.300049 5.70001Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 3.50001C15.7 5.32255 12.2526 6.80001 8.00005 6.80001C3.74745 6.80001 0.300049 5.32255 0.300049 3.50001C0.300049 1.67747 3.74745 0.200012 8.00005 0.200012C12.2526 0.200012 15.7 1.67747 15.7 3.50001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.7fed833ea448cec9278fba57218ba146.svg";
export { ForwardRef as ReactComponent };